// extracted by mini-css-extract-plugin
module.exports = {"dropdown-compact":"style_dropdown-compact__2hMFo","timeframe":"style_timeframe__3r_6r","vibrate":"style_vibrate__31Gi6","shake":"style_shake__3ryg9"};